import 'css-chunksrc/feature/provision/ProvisionerLanding.module.scss';export default {
  "pageContentReset": "ProvisionerLanding_pageContentReset",
  "pageContent": "ProvisionerLanding_pageContent",
  "splash": "ProvisionerLanding_splash",
  "splashItem": "ProvisionerLanding_splashItem",
  "actionContainer": "ProvisionerLanding_actionContainer",
  "logo": "ProvisionerLanding_logo"
};